import React from 'react';
import { Link } from 'react-router-dom';

const PageNotFount = () => {
  return (
    <section className='not-found-page' aria-labelledby='not-found-title'>
      <div className='not-found-content'>
        <p className='not-found-code' aria-hidden='true'>
          404
        </p>
        <p className='not-found-kicker'>Lost in the frame?</p>
        <h1 id='not-found-title'>Page not found</h1>
        <p className='not-found-message'>
          The page you are looking for may have moved, changed, or never made
          it into the final gallery.
        </p>
        <div className='not-found-actions'>
          <Link className='btn btn-dark' to='/'>
            Back home
          </Link>
          <Link className='btn btn-outline-dark' to='/portrait'>
            View photography
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PageNotFount;
